module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "detail-card"
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v("for product groups or types eg. colors, materials, plans, sizes etc")]), _vm._v(" "), _c('div', {
    staticClass: "card card-colord-pad card-colord-01",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('div', {}, [_c('p', [_c('b', [_vm._v("Group Name: ")]), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.product.product_groups_set_name))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(eg: Colours)")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Sub Group Name: ")]), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name))]), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(eg: Sizes)")])]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "line-height": "0.8"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('setProductSettings', '', '')
      }
    }
  }, [_vm._v(" Change Group Name and Sub Group Name")]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.product_details.setProductSettings) ? _c('div', [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('b', [_vm._v("Group Name: ")]), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(eg: Colours)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_set_name),
      expression: "product.product_groups_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_set_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('b', [_vm._v("Group Items Name: ")]), _c('span', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("(eg: Sizes)")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_groups_items_set_name),
      expression: "product.product_groups_items_set_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_groups_items_set_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_groups_items_set_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editProductSettings
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02 sp-button-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('div', {
    staticClass: "card card-out-colord-pad"
  }, [(_vm.product.product_set_groups == 0) ? _c('div') : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1em 0",
      "display": "none"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02",
    staticStyle: {
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Product Variation")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (!_vm.product_details.addProductItemPanel) ? _c('div', {
    staticClass: "card card-out-colord-pad",
    staticStyle: {
      "margin-top": "1.5em"
    }
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right",
      "line-height": "1.2"
    },
    on: {
      "click": function($event) {
        _vm.setProductComponent('addProductItemPanel', '', '')
      }
    }
  }, [_vm._v("Add new Group")]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v("Product Groups/Types ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (((_vm.product.product_set_groups > 0) && (_vm.product.product_set_items > 0))) ? _c('div', {}, _vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pg.id,
      staticClass: "card card-flat-pad",
      staticStyle: {
        "border": "#f7f7f7 solid !important"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "90%"
      }
    }, [_c('div', [_c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v("  " + _vm._s(Object.keys(pg.product_items).length) + " items")]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "z-index": "3"
      }
    }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "-1.5em"
      }
    }, [_c('b', [_vm._v(_vm._s(pg.product_item_group_name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('div', [(_vm.menu_tab_inner_view['PGITMS' + pgdex]) ? _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('')
        }
      }
    }, [_vm._m(1, true)]) : _c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabInnerView('PGITMS' + pgdex)
        }
      }
    }, [_vm._m(2, true)])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), (_vm.menu_tab_inner_view['PGITMS' + pgdex]) ? _c('div', [_c('div', {
      staticClass: "orders-panel",
      staticStyle: {
        "margin-top": "1em"
      }
    }, [((!_vm.product_details.editProductItemGroup && !_vm.product_details.removeItemGroup && !_vm.product_details.addProductItemToGroup)) ? _c('div', [_c('div', {
      staticClass: "card card-strip"
    }, [_c('span', [_c('a', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('editProductItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v("Edit Group")])]), _vm._v("   \n                    "), (_vm.product.product_item_groups && _vm.product.product_item_groups.length > 1) ? _c('span', [_c('a', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('removeItemGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v("Delete group")])]) : _vm._e()]), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('h5', {
      staticStyle: {
        "font-size": "10px",
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.product.product_groups_items_set_name) + "\n                          ")]), _vm._v(" "), _vm._l((pg.product_items), function(pt, ptdex) {
      return _c('div', {
        key: ptdex,
        staticClass: "items-list-tiny",
        staticStyle: {
          "display": "inline"
        }
      }, [_c('div', {
        staticClass: "row",
        staticStyle: {
          "padding": "1em"
        }
      }, [_c('div', {
        staticClass: "box-cube col-xs-2 mp-flat",
        staticStyle: {
          "margin": "0",
          "padding": "0"
        }
      }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', {
        staticClass: "box-color-cube",
        staticStyle: {
          "z-index": "3"
        }
      }, [((pg.product_item_group_image && (pg.product_item_group_image != 'error'))) ? _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": pg.product_item_group_image
        }
      }) : _c('img', {
        staticClass: "sp-prd-img",
        attrs: {
          "src": "/static/assets/images/dummy-image.png"
        }
      })]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
        staticClass: "box-color-cube",
        style: ({
          background: pg.product_item_group_color
        })
      })]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-9 mp-flat",
        staticStyle: {
          "margin": "0",
          "padding": "0"
        }
      }, [(_vm.product.product_service == 'P' && (pt.product_item_size)) ? _c('span', {
        staticStyle: {
          "font-weight": "bolder",
          "font-size": "10px"
        }
      }, [_vm._v(_vm._s(pt.product_item_size))]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S' && (pt.product_item_service_tag)) ? _c('span', {
        staticStyle: {
          "font-weight": "bolder",
          "font-size": "10px"
        }
      }, [_vm._v(_vm._s(pt.product_item_service_tag))]) : _vm._e(), _vm._v(" "), _c('span', [_c('a', {
        staticClass: "sp-app-default-color",
        staticStyle: {
          "cursor": "pointer",
          "font-size": "10px"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('editProductItem', 'productitem', pt)
          }
        }
      }, [_vm._v("Edit")])]), _vm._v(" "), (_vm.product.product_items.length > 1) ? _c('span', [_c('a', {
        staticClass: "sp-app-default-color",
        staticStyle: {
          "cursor": "pointer",
          "font-size": "10px"
        },
        on: {
          "click": function($event) {
            _vm.setProductComponent('removeProductItem', 'productitem', pt)
          }
        }
      }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
        staticStyle: {
          "font-size": "11px"
        }
      }, [(_vm.product.product_service == 'P') ? _c('span', [_vm._m(3, true), _vm._v(_vm._s(pt.product_item_weight))]) : _vm._e(), _vm._v(" "), (pt.product_item_actual_price != 0) ? _c('span', [_vm._m(4, true), _vm._v(_vm._s(pt.product_item_actual_price))]) : _c('span', [_vm._m(5, true), _vm._v(_vm._s(pt.product_item_price))]), _vm._v(" "), _c('span', [_vm._m(6, true), _vm._v(_vm._s(pt.product_item_quantity))])])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]), _vm._v(" "), (_vm.product_details.editProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('div', {
        staticClass: "col-sm-12",
        staticStyle: {
          "margin-top": "1em",
          "margin-bottom": "1em"
        },
        attrs: {
          "id": "editProductItem"
        }
      }, [_c('h6', {
        attrs: {
          "align": "left"
        }
      }, [_vm._v("Edit Product Item")]), _vm._v(" "), _c('form', {
        staticClass: "sp-form"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [(_vm.product.product_service == 'P') ? _c('span', [_vm._v(" Size")]) : _vm._e(), (_vm.product.product_service == 'S') ? _c('span', [_vm._v(" Type")]) : _vm._e(), _vm._v(" "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_size),
          expression: "product_item.product_item_size"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_size)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_size = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Service Tag\n                                  "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_service_tag),
          expression: "product_item.product_item_service_tag"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_service_tag)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_service_tag = $event.target.value
          }
        }
      })])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Price\n                                        "), (_vm.product_item.product_item_actual_price != 0) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_actual_price),
          expression: "product_item.product_item_actual_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_actual_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_actual_price = $event.target.value
          }
        }
      }) : _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_price),
          expression: "product_item.product_item_price"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "value": "",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_price)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_price = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Weight\n                                      "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_weight),
          expression: "product_item.product_item_weight"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "step": "any",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_weight)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_weight = $event.target.value
          }
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "form-group col-xs-6"
      }, [_c('label', [_vm._v(" Quantity\n                                      "), _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product_item.product_item_quantity),
          expression: "product_item.product_item_quantity"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product_item.product_item_quantity)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product_item.product_item_quantity = $event.target.value
          }
        }
      })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
        staticClass: "col-md-3 col-xs-12"
      }, [_vm._m(7, true), _c('br'), _vm._v(" "), (_vm.product_item.product_item_service_duration != '') ? _c('label', [_c('b', [_vm._v("SET: " + _vm._s(_vm.product_item.product_item_service_duration))])]) : _vm._e(), _vm._v(" "), _c('table', {
        staticStyle: {
          "width": "100%"
        }
      }, [_c('tr', [_c('td', {
        staticStyle: {
          "width": "30%"
        }
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.product.product_item_service_duration),
          expression: "product.product_item_service_duration"
        }],
        staticClass: "form-control",
        staticStyle: {
          "width": "100%"
        },
        attrs: {
          "type": "number",
          "placeholder": ""
        },
        domProps: {
          "value": (_vm.product.product_item_service_duration)
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.product.product_item_service_duration = $event.target.value
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticStyle: {
          "width": "70%"
        }
      }, [_c('select', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.service_duration),
          expression: "service_duration"
        }],
        staticClass: "form-control",
        on: {
          "change": function($event) {
            var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
              return o.selected
            }).map(function(o) {
              var val = "_value" in o ? o._value : o.value;
              return val
            });
            _vm.service_duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
          }
        }
      }, [_c('option', {
        domProps: {
          "value": undefined
        }
      }, [_vm._v("Select")]), _vm._v(" "), _c('option', [_vm._v("days")]), _vm._v(" "), _c('option', [_vm._v("months")]), _vm._v(" "), _c('option', [_vm._v("years")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "col-md-12 col-xs-12"
      }, [(_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e(), _vm._v(" "), _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-02 sp-button-md",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "disabled": _vm.disable_btn,
          "type": "button"
        },
        on: {
          "click": _vm.editProductItem
        }
      }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
        staticClass: "btn sp-button-02 sp-button-md",
        staticStyle: {
          "line-height": "1.2",
          "margin-right": "5px"
        },
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-ban"
      }), _vm._v(" Cancel")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr')])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      })]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.product_details.removeProductItem && (_vm.product_item.product_item_id == pt.product_item_id)) ? _c('span', {}, [_c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("Do you really want to remove this Item?")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs sp-button-02 sp-button-sm",
        attrs: {
          "disabled": _vm.disable_btn
        },
        on: {
          "click": function($event) {
            _vm.removeProductItem()
          }
        }
      }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-xs sp-button-02 sp-button-sm",
        on: {
          "click": function($event) {
            _vm.setComponent('reset-edit', '')
          }
        }
      }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
        staticClass: "loading-sm"
      }) : _vm._e()]) : _vm._e()])])
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-02 sp-button-sm",
      staticStyle: {
        "float": "right"
      },
      on: {
        "click": function($event) {
          _vm.setProductComponent('addProductItemToGroup', 'productitemgroup', pg)
        }
      }
    }, [_vm._v(" Add New Item")])], 2), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.product_details.editProductItemGroup || _vm.product_details.removeItemGroup) ? _c('div', {}, [(_vm.product_details.editProductItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "col-sm-12",
      attrs: {
        "id": "editProductItemGroup"
      }
    }, [_c('h6', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("Edit Group ")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_name),
        expression: "product_item_group.product_item_group_name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_name = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('p', [_vm._v("Group Label (Colour/Image)")]), _vm._v(" "), _c('div', {
      staticClass: "box-cube"
    }, [(_vm.product_item_group.product_item_group_is_color_image == 'IMG') ? _c('div', {}, [((_vm.product_item_group.product_item_group_image && (_vm.product_item_group.product_item_group_image != 'error'))) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": _vm.product_item_group.product_item_group_image
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.product_item_group.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "box-color-cube",
      style: ({
        background: pg.product_item_group_color
      })
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]), _vm._v(" "), _vm._m(8, true), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12"
    }, [_c('label', {
      staticClass: "col-xs-4",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('input', {
      staticStyle: {
        "height": "1em"
      },
      attrs: {
        "type": "radio",
        "name": "prt-color-image",
        "value": "colour"
      },
      on: {
        "click": function($event) {
          _vm.toggleDoubleComponent('prt-color-edit', 'prt-image-edit')
        }
      }
    }), _vm._v("\n                          Colour\n                        ")]), _vm._v(" "), _c('label', {
      staticClass: "col-xs-4",
      staticStyle: {
        "margin": "0",
        "padding": "0"
      }
    }, [_c('input', {
      staticStyle: {
        "height": "1em"
      },
      attrs: {
        "type": "radio",
        "name": "prt-color-image",
        "value": "image"
      },
      on: {
        "click": function($event) {
          _vm.toggleDoubleComponent('prt-image-edit', 'prt-color-edit')
        }
      }
    }), _vm._v("\n                          Image\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "clear": "both",
        "display": "none",
        "padding": "1em"
      },
      attrs: {
        "id": "prt-color-edit"
      }
    }, [_c('label', {
      staticClass: "sp-app-default-color"
    }, [_vm._v(" Select a Colour ")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product_item_group.product_item_group_color_new),
        expression: "product_item_group.product_item_group_color_new"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "4em"
      },
      attrs: {
        "type": "color"
      },
      domProps: {
        "value": (_vm.product_item_group.product_item_group_color_new)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product_item_group.product_item_group_color_new = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12",
      staticStyle: {
        "clear": "both",
        "display": "none",
        "padding": "1em"
      },
      attrs: {
        "id": "prt-image-edit"
      }
    }, [(_vm.product.product_images && (Object(_vm.product.product_images).length > 0)) ? _c('div', [_c('label', [_vm._v("Pick Image")]), _vm._v(" "), _c('div', {
      staticClass: "row img-row"
    }, _vm._l((_vm.product.product_images), function(img, index) {
      return _c('div', {
        key: index,
        staticClass: "col-xs-1",
        staticStyle: {
          "height": "40px",
          "width": "100px",
          "margin-bottom": "5px"
        },
        attrs: {
          "id": "groupImage"
        }
      }, [_c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.setInnerComponent('set-product-item-group-image', img.product_image_id)
          }
        }
      }, [_c('img', {
        staticClass: "product-item-group-image sp-prd-img",
        attrs: {
          "id": img.product_image_id + 'PRTG',
          "src": img.product_image,
          "alt": ""
        }
      })])])
    })), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "z-index": "9"
      }
    }, [_c('div', {
      staticClass: "upload-btn-wrapper",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "id": "uploadDiv"
      }
    }, [_c('button', {
      staticClass: "upload-btn sp-button-02 sp-button-md",
      staticStyle: {
        "line-height": "1.2"
      }
    }, [_vm._v("Add new Image")]), _vm._v(" "), _c('input', {
      attrs: {
        "type": "file",
        "id": "input-file",
        "accept": "image/*"
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, 'products', _vm.product.product_id)
        }
      }
    })])]), _c('hr')]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-12"
    }, [(_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-md",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.editProductItemGroup
      }
    }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-md",
      staticStyle: {
        "line-height": "1.2",
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-ban"
    }), _vm._v(" Cancel")])])])]) : _vm._e(), _vm._v(" "), (_vm.product_details.removeItemGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {}, [_c('span', {}, [_c('p', {
      staticStyle: {
        "color": "#ff0000"
      }
    }, [_vm._v("Do you really want to remove this Group?")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.removeProductItemGroup()
        }
      }
    }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs sp-button-02 sp-button-sm",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.product_details.addProductItemToGroup && (_vm.product_item_group.product_item_group_id == pg.product_item_group_id)) ? _c('div', {
      staticClass: "row"
    }, [(_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('label', [_vm._v("Attributes (eg: Size, Plan, Length etc,)\n                          "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_size),
        expression: "product.product_item_size"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_size)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_size = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
      staticClass: "col-md-4 col-xs-4"
    }, [_c('label', [_vm._v(" Service Tag\n                            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_service_tag),
        expression: "product.product_item_service_tag"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_service_tag)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_service_tag = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Price\n                            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_price),
        expression: "product.product_item_price"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "value": "",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_price)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_price = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Weight(KG)\n                            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_weight),
        expression: "product.product_item_weight"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "step": "any",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_weight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_weight = $event.target.value
        }
      }
    })])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_c('label', [_vm._v(" Quantity\n                            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_quantity),
        expression: "product.product_item_quantity"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_quantity = $event.target.value
        }
      }
    })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
      staticClass: "col-md-3 col-xs-6"
    }, [_vm._m(9, true), _vm._v(" "), _c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "30%"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.product_item_service_duration),
        expression: "product.product_item_service_duration"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "number",
        "placeholder": ""
      },
      domProps: {
        "value": (_vm.product.product_item_service_duration)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.product.product_item_service_duration = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "70%"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.service_duration),
        expression: "service_duration"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.service_duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      domProps: {
        "value": undefined
      }
    }, [_vm._v("Select")]), _vm._v(" "), _c('option', [_vm._v("days")]), _vm._v(" "), _c('option', [_vm._v("months")]), _vm._v(" "), _c('option', [_vm._v("years")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-md-6 col-xs-12"
    }, [_c('p', {
      staticClass: "data-error-message"
    }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
      staticClass: "data-success-message"
    }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
      staticClass: "loading-sm"
    }) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-md",
      attrs: {
        "disabled": _vm.disable_btn,
        "type": "button"
      },
      on: {
        "click": _vm.addProductItem
      }
    }, [_vm._v("Add Item")]), _vm._v(" "), _c('button', {
      staticClass: "btn sp-button-02 sp-button-md",
      on: {
        "click": function($event) {
          _vm.setComponent('reset-edit', '')
        }
      }
    }, [_vm._v("Cancel")])])]) : _vm._e()])]) : _vm._e()])
  })) : _c('div', {
    staticStyle: {
      "margin": "5px 0.89em"
    }
  }, [_c('p', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("You have not set any Product item variation")])])]) : _vm._e(), _vm._v(" "), (_vm.product_details.addProductItemPanel) ? _c('div', {}, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    staticStyle: {
      "float": "right",
      "line-height": "1.2"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Cancel")]), _vm._v(" "), _c('h6', [_vm._v("Add New Group or Variation")]), _vm._v(" "), _c('form', {
    key: _vm.productVariationComponentKey,
    staticClass: "sp-form",
    staticStyle: {
      "margin-top": "1em",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.product.product_set_groups > 0) ? _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showtrue"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showtrue")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showtrue"
      }
    }
  }), _vm._v(" "), _vm._v("\n                          Add new Items to "), _c('span', [_vm._v(_vm._s(_vm.product.product_groups_set_name))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "line-wrap"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showProductItemGroups),
      expression: "showProductItemGroups"
    }],
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "value": "showfalse"
    },
    domProps: {
      "checked": _vm._q(_vm.showProductItemGroups, "showfalse")
    },
    on: {
      "__c": function($event) {
        _vm.showProductItemGroups = "showfalse"
      }
    }
  }), _vm._v("\n                              Or Add new " + _vm._s(_vm.product.product_groups_set_name) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showProductItemGroups == 'showtrue') ? _c('div', [_c('br'), _vm._v(" "), _vm._m(10), _vm._v(" "), ((_vm.product.product_item_groups.length && _vm.product.product_item_groups.length > 0)) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._l((_vm.product.product_item_groups), function(pg, pgdex) {
    return _c('div', {
      key: pgdex
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [_c('div', {
      staticStyle: {
        "padding": "5px",
        "margin-bottom": "5px",
        "width": "10%"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "title": pg.product_item_group_name
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group', pg)
        }
      }
    }, [(pg.product_item_group_is_color_image == 'IMG') ? _c('div', [_c('div', {
      staticClass: "box-color-cube"
    }, [_c('img', {
      staticClass: "product-item-group sp-prd-img",
      attrs: {
        "src": pg.product_item_group_image,
        "id": pg.product_item_group_id + 'PRTGR'
      }
    })])]) : _vm._e(), _vm._v(" "), (pg.product_item_group_is_color_image == 'COL') ? _c('div', [_c('div', {
      staticClass: "product-item-group",
      attrs: {
        "id": pg.product_item_group_id + 'PRTGR'
      }
    }, [_c('div', {
      staticClass: "box-color-cube",
      staticStyle: {
        "height": "3em",
        "width": "85%"
      },
      style: ({
        background: pg.product_item_group_color
      })
    })])]) : _vm._e(), _vm._v(" "), _c('p', {
      staticStyle: {
        "color": "#000000",
        "font-weight": "bold",
        "font-size": "12px",
        "line-height": "1.2",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(pg.product_item_group_name))])])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showProductItemGroups == 'showfalse') ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("Name of new " + _vm._s(_vm.product.product_groups_set_name) + " "), _c('br'), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_vm._v("(eg:Blue,Black,Custom,Anyname..)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_name),
      expression: "product.product_item_group_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.product.product_item_group_name)
    },
    on: {
      "change": function($event) {
        (_vm.productVariationComponentKey++)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    staticStyle: {
      "font-size": "16px",
      "margin": "0",
      "padding": "0"
    }
  }, [_vm._v("Group Colour/Image")]), _vm._v(" "), _c('label', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('input', {
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "name": "prt-color-image",
      "value": "colour"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('prt-color', 'prt-image')
      }
    }
  }), _vm._v("\n                        Colour\n                      ")]), _vm._v(" "), _c('label', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('input', {
    staticStyle: {
      "height": "1em"
    },
    attrs: {
      "type": "radio",
      "name": "prt-color-image",
      "value": "image"
    },
    on: {
      "click": function($event) {
        _vm.toggleDoubleComponent('prt-image', 'prt-color')
      }
    }
  }), _vm._v("\n                        Image\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both",
      "display": "none",
      "padding": "1em"
    },
    attrs: {
      "id": "prt-color"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Pick Colour\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_group_color),
      expression: "product.product_item_group_color"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "4em"
    },
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.product.product_item_group_color)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_group_color = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "clear": "both",
      "display": "none",
      "border": "1px dashed #eeccee",
      "padding": "1em"
    },
    attrs: {
      "id": "prt-image"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(" Or Pick Image ")]), _vm._v(" "), _c('div', {
    staticClass: "row img-row"
  }, [_vm._l((_vm.product.product_images), function(img, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-1",
      staticStyle: {
        "height": "50px",
        "width": "70px"
      },
      attrs: {
        "id": "groupImage"
      }
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.setInnerComponent('set-product-item-group-image', img.product_image_id)
        }
      }
    }, [_c('img', {
      staticClass: "product-item-group-image sp-prd-img",
      attrs: {
        "id": img.product_image_id + 'PRTG',
        "src": img.product_image,
        "alt": ""
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "z-index": "9"
    }
  }, [_c('p', {
    staticClass: "p-tiny-info"
  }, [_vm._v(_vm._s(_vm.max_media_info))]), _vm._v(" "), _c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer",
      "margin-top": "2em"
    }
  }, [_c('button', {
    staticClass: "sp-button-02 sp-button-sm",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Or Add new Image or Video ")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "video/*,image/*",
      "capture": ""
    },
    on: {
      "change": function($event) {
        _vm.onFileChangeProductItems($event, 'products', _vm.product.product_id)
      }
    }
  })]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_media_error_message))])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('br')]), _vm._v(" "), ((_vm.showProductItemGroups == 'showtrue') || (_vm.showProductItemGroups == 'showfalse')) ? _c('div', {
    key: _vm.productAddView02ComponentKey,
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    staticClass: "sp-app-default-text-color-dim-1",
    staticStyle: {
      "color": "#898989"
    }
  }, [_vm._v("Add an Item to this Group\n                      "), (_vm.product.product_item_group_name && (_vm.product.product_item_group_name != '')) ? _c('span', [_vm._v("\n                      : ("), _c('b', [_vm._v(_vm._s(_vm.product.product_item_group_name))]), _vm._v(")")]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('span', [_vm._v("(eg:sizes,lengths,materials)")]) : _vm._e()])]), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "1em",
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "col-xs-5"
  }, [_vm._v(" \n                    " + _vm._s(_vm.product.product_groups_items_set_name)), _c('br'), _vm._v("(eg:sizes,lengths,materials)\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-1"
  }, [_vm._v(" - ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("\n                      (eg:big,long,short,xl,m...)"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_size),
      expression: "product.product_item_size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_size)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_size = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('label', [_vm._v(" Service Tag "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_tag),
      expression: "product.product_item_service_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_tag = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_c('label', [_vm._v(" Price\n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_price),
      expression: "product.product_item_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_price = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.product.product_service == 'S') ? _c('div', {
    staticClass: "col-md-3 col-xs-6"
  }, [_vm._m(12), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_service_duration),
      expression: "product.product_item_service_duration"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_service_duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_service_duration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service_duration),
      expression: "service_duration"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.service_duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": undefined
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', [_vm._v("days")]), _vm._v(" "), _c('option', [_vm._v("months")]), _vm._v(" "), _c('option', [_vm._v("years")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Weight(KG)\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_weight),
      expression: "product.product_item_weight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "any",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_weight = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.product.product_service == 'P') ? _c('div', {
    staticClass: "col-md-3 col-xs-3"
  }, [_c('label', [_vm._v(" Quantity\n                          "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.product_item_quantity),
      expression: "product.product_item_quantity"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.product.product_item_quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.product.product_item_quantity = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-xs-12",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('p', {
    staticClass: "data-error-message"
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('p', {
    staticClass: "data-success-message"
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), (_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.addProductItem
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.setComponent('reset-edit', '')
      }
    }
  }, [_vm._v("Cancel")])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', [_c('b', [_vm._v("Product Types / Groups")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('i', {
    staticClass: "fa fa-angle-down"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Wt(kg):")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Price:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Price:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("Qty:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Duration "), _c('span', {
    staticClass: "sp-info-sm"
  }, [_vm._v("eg: 3 months")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('label', {
    staticClass: "sp-app-default-color"
  }, [_vm._v("To change Group Label, pick Colour or Image")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Duration "), _c('span', {
    staticClass: "sp-info-sm"
  }, [_vm._v("eg: 3 months")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Select a Group from below:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Name of item / Describe product "), _c('br'), _vm._v("(eg:big,long,short,xl,m...)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v(" Duration "), _c('span', {
    staticClass: "sp-info-sm"
  }, [_vm._v("eg: 3 months")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-830b94c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account/Sellpoint/Product/ProductTypes.vue
// module id = 611
// module chunks = 0